function compareArrays(a, b) {
    var elA, elB, i, len;
    for (i = 0, len = Math.min(a.length, b.length); i < len; i++) {
        elA = a[i], elB = b[i];
        if (elA > elB) return 1;
        if (elA < elB) return -1;
    }
    return b.length - a.length;
};

export function orderBy(arr, pred)
{
  arr.sort((e1,e2) => compareArrays(pred(e1), pred(e2)));  
  return arr;
}


// WEBPACK FOOTER //
// ./src/features/common/orderby.js